import BaseModelAPI from '../BaseModelAPI';

export default class ReportMTTR extends BaseModelAPI {
	static entity = 'newreport2016';
	static entityName = 'reportmttr';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.filterPeriodDate = '';
			this.filterLotNo = '';
			this.filterStartDate = '';
			this.filterFinishDate = '';
			this.filterMachineCode = '';
			this.tempId = 0;
			this.woDate = '';
			this.lotNo = '';
			this.standarTimeName = '';
			this.startProduction = '';
			this.finishProduction = '';
			this.code = '';
			this.woeId = 0;
			this.troubleReport = '';
			this.analisaDanPenyebab = '';
			this.tindakan = '';
			this.eksIn = '';
			this.pic = '';
			this.hourMinuteStart = '';
			this.hourMinuteEnd = '';
			this.differenceHhMm = '';
			this.totalMinutes = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
			this.maintenanceHistoryId = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}